import { cx } from '@lastbrand/web-ui-styled-system/css'
import React, { FC, PropsWithChildren, useId } from 'react'

import { OptionProp } from '@src/quince-site-pdp/src/atoms/optionSelector/OptionSelector.constant'

import { inputClass, labelClass, outOfStockClass, srOnlyClass } from './option-container-ds.styles'

export type OptionContainerDSProps = {
  srOnly: boolean
  value: string
  displayName?: string
  inputClassName?: string
  labelClassName?: string
  disabled?: boolean
  onChange?: (value: string) => void
  lastChanceSizes?: (string | undefined)[]
} & Pick<OptionProp, 'selectionSetId' | 'isSelected'>

/**
 * Native `<input type="radio">` + `<label htmlFor>`. The shared `name`
 * (`selectionSetId`) is required for radiogroup keyboard a11y, and the
 * `data-testid="option-container_<value>"` is relied on by callers/tests.
 */
export const OptionContainerDS: FC<PropsWithChildren<OptionContainerDSProps>> = ({
  children,
  value,
  displayName,
  isSelected,
  srOnly,
  disabled,
  selectionSetId,
  inputClassName,
  labelClassName,
  onChange,
  lastChanceSizes,
}) => {
  const id = useId()
  const isOutOfStock = lastChanceSizes?.includes(value)
  return (
    <>
      <input
        data-testid={`option-container_${value}`}
        type="radio"
        id={id}
        className={cx(inputClass, inputClassName)}
        name={selectionSetId}
        checked={isSelected}
        onChange={() => {
          if (onChange) onChange(value)
        }}
        value={value}
        disabled={disabled}
      />
      <label htmlFor={id} className={cx(labelClass, labelClassName, isOutOfStock && outOfStockClass)}>
        {children}
        {srOnly ? <span className={srOnlyClass}>{displayName ?? value}</span> : null}
      </label>
    </>
  )
}
